import { createAsyncThunk } from '@reduxjs/toolkit';

import { showError } from '@/app/actions';
import { carAPI } from '@/modules/car/api';
import { namespace } from '@/modules/car/namespace';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { deleteCarFromStore } from '../actions';

let lastRequestId: string | undefined;

interface IParams {
  onSuccess?: () => void;
  carId: string;
}

const deleteCar = createAsyncThunk(
  `${namespace}/delete-car`,
  async ({ carId, onSuccess }: IParams, { dispatch, requestId }): Promise<ThunkResult<string>> => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      if (!carId) {
        return { isSucceed: false };
      }

      const result = await carAPI.deleteCar(carId);

      if ('deleted' in result) {
        dispatch(deleteCarFromStore({ carId }));
      } else {
        dispatch(showError(Object.values(result.errors).flat().join('\n')));
      }

      onSuccess?.();

      return { isSucceed: true };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { deleteCar };
